import React, { useState } from "react";
import axios from "axios";

import {
  API_URL
} from "./config/api";

function Login() {

  const [username, setUsername] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [isSubmitting, setIsSubmitting] =
    useState(false);


  const handleLogin = async () => {

        if (
          !username.trim() ||
          !password
        ) {
          alert(
            "Enter Admin Username and Password"
          );
          return;
        }

    try {

      setIsSubmitting(true);

      const response = await axios.post(
        `${API_URL}/api/admin/login`,
                {
                  username:
                    username
                      .trim()
                      .toLowerCase(),

                  password
                }
      );

      localStorage.setItem(
        "adminToken",
        response.data.token
      );

      window.location.href = "/admin";

    } catch (error) {

      localStorage.removeItem(
        "adminToken"
      );

      localStorage.removeItem(
        "isAdmin"
      );

      alert(
        error.response?.data?.message ||
        "Login failed"
      );

    } finally {

      setIsSubmitting(false);

    }

  };


  return (

  <main className="admin-login-page">

    <div className="admin-login-card">

      <div className="admin-login-accent" />


      <div className="admin-login-header">

        <span className="admin-login-eyebrow">
          Chatra Sangbad
        </span>

        <h1>
          Admin Login
        </h1>

        <p>
          Sign in to access the administrative
          dashboard and content management tools.
        </p>

      </div>


      <div className="admin-login-form">

        <div className="admin-login-field">

          <label htmlFor="admin-username">
            Username
          </label>

          <input
            id="admin-username"
            type="text"
            placeholder="Enter Admin Username"
            value={username}
            autoComplete="username"
            autoCapitalize="none"
            spellCheck="false"
            onChange={(e) =>
              setUsername(
                e.target.value
              )
            }
          />

        </div>


        <div className="admin-login-field">

          <label htmlFor="admin-password">
            Password
          </label>

          <input
            id="admin-password"
            type="password"
            placeholder="Enter Admin Password"
            value={password}
            autoComplete="current-password"
            onChange={(e) =>
              setPassword(
                e.target.value
              )
            }
            onKeyDown={(e) => {

              if (
                e.key === "Enter" &&
                !isSubmitting
              ) {

                handleLogin();

              }

            }}
          />

        </div>


        <button
          type="button"
          className="admin-login-button"
          onClick={handleLogin}
          disabled={isSubmitting}
        >
          {isSubmitting
            ? "Logging in..."
            : "Login"}
        </button>

      </div>


      <div className="admin-login-footer">

        <span>
          Authorized administrators only
        </span>

      </div>

    </div>

  </main>

);

}

export default Login;